export const openContactPage = () => {
  window.open('https://edudip.com/kontakt');
};
